//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfPOtherValidation",
    props: {
        valueErrMsg: { type: String, default: "" },
        labelErrMsg: { type: String, default: "" },
        disable: { type: Boolean, default: false },
        otherType: { type: String, default: "" },
        expression: { type: String, default: "" },
        changeOrDefocus: { type: String, default: "ondefocus" }
    },
    data() {
        return {
            showExpression: false,
            // eslint-disable-next-line
            emailRegex: "^(?=.{1,256})(?=.{1,64}@)(?=[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,63}$)[\\w-]+(\\.[\\w-]+)*@[a-zA-Z\\d-]+(\\.[a-zA-Z\\d-]+)*\\.([a-zA-Z]{2,})$",
            ibanRegex: "^([A-Z]{2}[-]?[0-9]{2})(?=(?:[-]?[A-Z0-9]){9,30}$)((?:[-]?[A-Z0-9]{3,5}){2,7})([-]?[A-Z0-9]{1,3})?$",
            // eslint-disable-next-line
            urlRegex: "^(https?|ftp):\/\/(www\\.)?[^\\s(\\)$.?#].[^\\s]*$",
            options: [
                { label: this.$t("userInterface.validation.emailOpt"), value: "email" },
                { label: this.$t("userInterface.validation.ibanOpt"), value: "iban" },
                { label: this.$t("userInterface.validation.regexOpt"), value: "regex" },
                { label: this.$t("userInterface.validation.urlOpt"), value: "url" }
            ]
        };
    },
    computed: {
        errMsgValue: {
            get() {
                return this.valueErrMsg;
            },
            set(val) {
                this.$emit("errMsgChange", val);
            }
        },
        changeOrDefocusVal: {
            get() {
                return this.changeOrDefocus;
            },
            set(val) {
                this.$emit("setChangeOrDefocusVal", val);
            }
        },
        expressionToShow: {
            get() {
                return this.expression;
            },
            set(val) {
                this.$emit("setExpression", val);
            }
        },
        localValue: {
            get() {
                return this.otherType;
            },
            set(val) {
                this.setExpression(val);
                this.$emit("input", val);
            }
        }
    },
    methods: {
        setExpression(val) {
            let valueToShow = "";
            if (val === "email") {
                valueToShow = this.emailRegex;
            } else if (val === "iban") {
                valueToShow = this.ibanRegex;
            } else if (val === "url") {
                valueToShow = this.urlRegex;
            }
            this.$emit("setExpression", valueToShow);
        }
    }
};
